<template>
<div class="body apply">
    <div class="wrap" style="width: inherit !important;">
        <div class="apply-menu-wrap1">
            <div class="top-menu">
                <h1>
                    <img v-if="logo" :src="logo" alt="company logo">
                    <div v-else style="height: 25px;"/>
                    <!-- <span>사내어학과정</span> -->
                    <div style="height:30px;"></div>
                </h1>
                <!-- 모바일용 -->
                <a href="#" class="dp-inblock-m m-menu" id="header-menu-btn">
                    <img src="../../assets/img/m_gnb_sub.png" alt="menu">
                </a>
                <ul>
                    <li class="on-blue">
                        <a>신청하기</a>
                    </li>
                    <li>
                        <a class="pointer">신청내역 확인</a>
                    </li>
                    <!-- <li :class="{'on-blue' : pageType === 'pw'}">
                        <a class="pointer" @click="moveFixPW()">비밀번호 재설정</a>
                    </li> -->
                    <li>
                        <a class="pointer">Logout</a>
                    </li>
                </ul>
            </div>
            <!-- 반응형 메뉴 -->
            <div class="dp-inblock-m m-top-menu" id="header-menu">
                <a href="#" class="close" id="header-close">
                    <img src="../../assets/img/menu_close.png" alt="">
                </a>
                <ul class="clear">
                    <li><a class="pointer">신청하기</a></li>
                    <li><a class="pointer">신청내역 확인</a></li>
                    <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
                    <li><a class="pointer">Logout</a></li>
                </ul>
            </div>
        </div>
        <div class="con">
            <div class="title">
                <h2>정보입력</h2>
                <p>신청을 위한 정보 입력을 해 주세요.</p>
            </div>
            <progress-bar></progress-bar>
            <div class="mt-50">
                <div class="apply-fieldset">
                    <div class="hq-table-row">
                        <p class="w-100per txt-right pb-10 font-14"><span class="txt-red">*</span> 필수 입력 사항입니다.</p>
                        <table>
                            <colgroup>
                                <col width="30%">
                                <col width="70%">
                            </colgroup>
                            <tbody>
                                <tr v-for="(item, index) of info" :key="index">
                                    <th>
                                        <!-- Email일때는 구분자가 E-mail@밖에 없으므로 include사용 -->
                                        <span v-if="item.item_name.includes('E-mail@')">이메일</span>
                                        <span v-else>{{item.item_name}}</span>
                                        <span class="txt-red" v-if="item.necessary_YN === 'Y'">*</span></th>
                                    <td v-if="item.option_info && item.option_info !== 'direct'">
                                        <span v-if="item.option_info && item.option_info !== 'direct'">
                                            <span class="ml-10" v-for="(option, index) of item.option_info.split('^')" :key="index"><input type="radio" v-model="item.value" :value="option">
                                                {{option}}
                                            </span>
                                        </span>
                                        <span class="ml-20" v-if="item.item_message">{{item.item_message}}</span>
                                    </td>
                                    <td v-else>
                                        <input id="" type="password" v-if="item.item_name === '비밀번호'" v-model="item.value" name="" class="h-30px" title="" required="">
                                        <input id="" v-else v-model="item.value" name="" class="h-30px" title="" required="">
                                        <span v-if="item.item_name.includes('E-mail@')">{{item.item_name.replace('E-mail', '')}}</span>
                                        <span class="ml-20" v-if="item.item_message">{{item.item_message}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="apply-agree-btn">
                <button type="button">수강신청 하기</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'

export default {
    data: () => ({
        sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
        info: [], // 사용자정보 입력을 동적으로 하기 위한 데이터 (ex 회사정보를 필수 입력란으로 정할지 말지)
        
        logo: '' // 미리보기 로고 url용
    }),

    watch: {
        // 등록 페이지 내의 현재 라우터 경로 감지
        // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
        '$route'() {
            if (this.$route.fullPath === '/user/reg/input') {
                this.loadSugangData()
            }
        }
    },

    mounted() {
        var oParams = GetUrlParams()
        this.pageIdx = oParams.pageIdx

        // TODO: 추후에 page idx 바꿔야함!!
        var pageIdx = this.pageIdx
        var params = {
            pageIdx: pageIdx
        }
        this.axios.get(this.axios.root + this.axios.port + `/sugang/info/${pageIdx}`, {
                params: params
            })
            .then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.logo = res.data.main.company_logo_file_url
                    for (var item of res.data.info) {
                        if (item.use_YN === 'Y') {
                            if (item.option_info.split('^').length > 1) {
                                item['value'] = item.option_info.split('^')[0]
                            } else {
                                item['value'] = ''
                            }
                            this.info.push(item)
                        }
                    }
                    console.log('this.info', this.info)
                } else {
                    alert(res.data.result)
                }
            })
    },

    methods: {
        // 세션 스토리지 수강신청 전체 데이터 loading
        loadSugangData() {
            this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
        },

        // 수강신청 하기
        apply() {
            // 깊은복사 다시해서 session에 넣는 이유
            // info.email에 그대로 @xxx.com을 추가해버리면 test@xxx.com@xxx.com 현상발생
            var info = JSON.parse(JSON.stringify(this.info))

            console.log(this.info)
            for (var [index, item] of this.info.entries()) {
                console.log('item', item)
                if (item.item_name === '이름') {
                    this.sessionData['name'] = item.value
                } else if (item.item_name === '비밀번호') {
                    this.sessionData['password'] = item.value
                } else if (item.item_name.includes('E-mail@')) {
                    this.sessionData['email'] = item.value + item.item_name.replace('E-mail', '')
                    info[index]['value'] = item.value + item.item_name.replace('E-mail', '')
                } else if (item.item_name === '사번') {
                    this.sessionData['number'] = item.value
                } else if (item.item_name === '휴대전화번호') {
                    this.sessionData['mobile'] = item.value
                } else if (item.item_name === '직급') {
                    this.sessionData['position'] = item.value
                }

                if (item.necessary_YN === 'Y' && item.value.trim() === '') {
                    if (item.item_name.includes('E-mail@')) {
                        alert('이메일을 입력해주세요.')
                        return false
                    } else {
                        alert(item.item_name + '을(를) 입력해주세요.')
                        return false
                    }
                }
            }

            this.sessionData['info'] = info
            sessionStorage.setItem("classData", JSON.stringify(this.sessionData));
            var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
            var idx = pOrder.indexOf('input') + 1
            sessionStorage.setItem('step', pOrder[idx])
            this.$router.push(`/user/reg/${pOrder[idx]}`)
        }
    }
}
</script>
